import { Box, FormControlLabel, Stack, Switch, TextField, Typography } from "@mui/material";

interface Props {
  footnote: string;
  isShown: boolean;
  onFootnoteChange: (footnote: string) => void;
  onIsShownChange: (isShown: boolean) => void;
}

const FOOTNOTE_MAX_LENGTH = 1000;

const PortalWidgetFootnoteSection = ({ footnote, isShown, onFootnoteChange, onIsShownChange }: Props) => (
  <Stack spacing={1} sx={{ py: 2.5 }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
      <Typography variant="subtitle1">Footnote</Typography>
      <FormControlLabel
        control={<Switch checked={isShown} onChange={(_, checked) => onIsShownChange(checked)} />}
        label="Shown"
      />
    </Box>

    {isShown && (
      <TextField
        multiline
        minRows={5}
        value={footnote}
        placeholder="Enter footnote text"
        onChange={(e) => onFootnoteChange(e.target.value)}
        slotProps={{ htmlInput: { maxLength: FOOTNOTE_MAX_LENGTH } }}
      />
    )}

    {isShown && (
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 2 }}>
        <Typography variant="caption" color="textSecondary">
          Plain text. Shown under the table in the portal.
        </Typography>
        <Typography variant="caption" color="textSecondary" sx={{ flexShrink: 0 }}>
          {footnote.length} / {FOOTNOTE_MAX_LENGTH}
        </Typography>
      </Box>
    )}
  </Stack>
);

export default PortalWidgetFootnoteSection;
